module.exports = __webpack_public_path__ + "static/logo-uber-eats-ed57b0d75c116e070bef6f13cc89c5bd.png";